import { computed, observable } from 'mobx'
import { GiftCardStatus } from '../../../graphQL/generated/enums'
import ModelStore from '../../../shared-lib/stores/ModelStore'
import { couponColors } from '../ExternalPromocodeStore/ExternalPromocodeModel'
import moment from 'moment'
import { $RootStore } from '../../../src/stores/RootStore'

export const defaultData = {
  _id: '',
  professionalId: '',
  amount: 0,
  expirationDate: moment().add(1, 'year').toDate(),
  code: '',
  receiverEmail: '',
  message: '',
  senderEmail: '',
  status: GiftCardStatus.Active,
  balance: 5000,
  transactions: [],
}

export default class ExternalGiftCardModel extends ModelStore {
  @observable accessor data: ExternalGiftCard = { ...defaultData }
  fetchMethodName = 'externalGiftCard'

  constructor(data: Partial<ExternalGiftCard>, rootStore: $RootStore) {
    super(data, rootStore)
    this.merge(data)
  }

  @computed get couponColor() {
    if (!this.data.code) return 'green'

    const index = this.data.code.charCodeAt(0) % couponColors.length
    return couponColors[index] || 'green'
  }
}